const state = {
  phone: '',
  gameStatus: '',
  tel: {
    tel: '',
    areatype: 0
  }
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/state.js